import { fmt, inputCls, boxCls } from './styles';

function PromoCard({
  promoCode, setPromoCode,
  appliedPromo, applyPromo, removePromo,
  promoLoading, promoError, promoSuccess, setPromoError,
  spTotal, spValorDescontoCP,
}) {
  return (
    <div className={`${boxCls} ${appliedPromo ? 'opacity-60' : ''}`} data-testid="promo-section">
      <p className="text-xs font-semibold text-[#111827] mb-2">Código Promocional</p>
      <input data-testid="promo-input" type="text" value={promoCode}
        onChange={(e) => { setPromoCode(e.target.value); setPromoError(''); }}
        disabled={!!appliedPromo} placeholder="Insira um código"
        className={`${inputCls} mb-2`} />
      <div className="text-xs space-y-1 mb-2">
        {appliedPromo ? (
          <div><span className="font-bold text-[#111827]">{spTotal?.ChaveCodigoPromocional || appliedPromo}</span></div>
        ) : (
          <p className="text-[#9CA3AF]">Nenhum código utilizado</p>
        )}
        <div className="flex justify-between">
          <span className="text-[#6B7280]">Desconto utilizado:</span>
          <span className="font-semibold text-[#0F1829]">{fmt(spValorDescontoCP)}</span>
        </div>
      </div>
      {promoError && <p className="text-xs text-red-600 mb-1">{promoError}</p>}
      {promoSuccess && <p className="text-xs text-green-600 mb-1">{promoSuccess}</p>}
      {appliedPromo ? (
        <button onClick={removePromo} data-testid="remove-promo-btn"
          className="mt-1 w-full py-1.5 text-xs font-medium border border-red-400 text-red-500 rounded hover:bg-red-50 transition-colors">
          Remover código
        </button>
      ) : (
        <button onClick={applyPromo} disabled={!promoCode.trim() || promoLoading} data-testid="apply-promo-btn"
          className="w-full py-1.5 text-xs font-medium border border-[#0F1829] text-[#0F1829] rounded hover:bg-[#F0F4FF] disabled:opacity-40 transition-colors">
          {promoLoading ? 'A validar...' : 'Usar código'}
        </button>
      )}
    </div>
  );
}

function ValesCard({
  valesValue, setValesValue, appliedVales, applyVales, removeVales,
  spValesPermitidos, spValesExistentes, spDescontoVale,
}) {
  const disabled = Number(spValesPermitidos) === 0;
  return (
    <div className={`${boxCls} ${disabled ? 'opacity-50' : ''}`} data-testid="vales-section">
      <p className="text-xs font-semibold text-[#111827] mb-2">Vales</p>
      <input data-testid="vales-input" type="text" value={valesValue}
        onChange={(e) => setValesValue(e.target.value)}
        placeholder="Insira um valor" disabled={disabled} className={`${inputCls} mb-2`} />
      <div className="text-xs space-y-1">
        <div className="flex justify-between"><span className="text-[#6B7280]">Disponíveis:</span><span className="font-semibold text-[#0F1829]">{fmt(spValesExistentes)}</span></div>
        <div className="flex justify-between"><span className="text-[#6B7280]">Utilizados:</span><span className="font-semibold text-[#0F1829]">{fmt(spDescontoVale)}</span></div>
        <div className="flex justify-between"><span className="text-[#6B7280]">Consegue utilizar:</span><span className="font-semibold text-[#0F1829]">{fmt(spValesPermitidos)}</span></div>
      </div>
      {(Number(spDescontoVale) > 0 || appliedVales > 0) && (
        <button onClick={removeVales} data-testid="remove-vales-btn"
          className="text-red-500 hover:underline text-xs mt-1">Remover</button>
      )}
      <button onClick={() => applyVales()}
        disabled={!valesValue || disabled} data-testid="apply-vales-btn"
        className="mt-2 w-full py-1.5 text-xs font-medium border border-[#0F1829] text-[#0F1829] rounded hover:bg-[#F0F4FF] disabled:opacity-40 transition-colors">
        Usar vales
      </button>
    </div>
  );
}

function CreditosCard({
  creditosValue, setCreditosValue, appliedCreditos, applyCreditos, removeCreditos,
  spCreditosPermitidos, spCreditosExistentes, spDescontoCreditos,
}) {
  const disabled = Number(spCreditosPermitidos) === 0;
  return (
    <div className={`${boxCls} ${disabled ? 'opacity-50' : ''}`} data-testid="creditos-section">
      <p className="text-xs font-semibold text-[#111827] mb-2">Créditos</p>
      <input data-testid="creditos-input" type="text" value={creditosValue}
        onChange={(e) => setCreditosValue(e.target.value)}
        placeholder="Insira um valor" disabled={disabled} className={`${inputCls} mb-2`} />
      <div className="text-xs space-y-1">
        <div className="flex justify-between"><span className="text-[#6B7280]">Disponíveis:</span><span className="font-semibold text-[#0F1829]">{fmt(spCreditosExistentes)}</span></div>
        <div className="flex justify-between"><span className="text-[#6B7280]">Utilizados:</span><span className="font-semibold text-[#0F1829]">{fmt(spDescontoCreditos)}</span></div>
        <div className="flex justify-between"><span className="text-[#6B7280]">Consegue utilizar:</span><span className="font-semibold text-[#0F1829]">{fmt(spCreditosPermitidos)}</span></div>
      </div>
      {(Number(spDescontoCreditos) > 0 || appliedCreditos > 0) && (
        <button onClick={removeCreditos} data-testid="remove-creditos-btn"
          className="text-red-500 hover:underline text-xs mt-1">Remover</button>
      )}
      <button onClick={() => applyCreditos()}
        disabled={!creditosValue || disabled} data-testid="apply-creditos-btn"
        className="mt-2 w-full py-1.5 text-xs font-medium border border-[#0F1829] text-[#0F1829] rounded hover:bg-[#F0F4FF] disabled:opacity-40 transition-colors">
        Usar créditos
      </button>
    </div>
  );
}

export default function DiscountsSection(props) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
      <PromoCard {...props} />
      <ValesCard {...props} />
      <CreditosCard {...props} />
    </div>
  );
}
